const Applications = (props: any) =>  {
  console.log(props);
  return (
    <div>Applications</div>
  )
}

export default Applications;